import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import React from 'react'
import PropTypes from 'prop-types'
import { injectIntl, FormattedMessage } from 'react-intl'
import { Game, Firebase, Auth } from '../../../Core'

import * as actions from '../mining.actions'
import * as phaseActions from '../../Phases/phases.actions'
import * as quizzesActions from '../../Quizzes/quizzes.actions'

import * as selectors from '../mining.selectors'
import * as indicatorsSelectors from '../../Indicators/indicators.selectors'
import * as phaseSelectors from '../../Phases/phases.selectors'
import * as quizzesSelectors from '../../Quizzes/quizzes.selectors'
import * as settingsSelectors from '../../Settings/settings.selectors'

import Card from './Card'

/**
 *  Pop up showed when you have finished the game
 */
class MiningSelectScreen extends React.Component {
  /**
   *  Component constructor.
   */
  constructor(props) {
    super(props)
    this.state = {
      showInfo: false,
    }
  }

  componentDidMount() {
    const { getCountDisputes } = this.props
    getCountDisputes()
  }

  closeMine() {
    const { phase, nextPhase, removeScreen } = this.props

    if (phase == 2) {
      nextPhase()
    }
    removeScreen('mining_screen')
  }

  goToDisputesHistory() {
    const { changeMiningScreen, getDisputesList } = this.props

    getDisputesList()
    changeMiningScreen('dispute_question_list')
  }

  renderAnswerQuestion() {
    const {
      changeMiningScreen,
      counters: { an_xt: answers_by_turn, an_t: turn_answers },
      answerPrizeCoins,
      isAnswerPenalized,
    } = this.props
    const { showInfo } = this.state

    let infoTooltip = 'tooltips.answer_question'
    return (
      <Card
        changeScreen={() => changeMiningScreen('answer_question')}
        signalNameId="mining.answer_question"
        count_current={answers_by_turn - turn_answers}
        count_total={answers_by_turn}
        penalized={isAnswerPenalized}
        prizeCoins={answerPrizeCoins}
        infoTooltip={infoTooltip}
        tooltipValue=""
        showInfo={showInfo}
        icon="icon-answer"
      />
    )
  }

  renderCreateQuestion() {
    const {
      changeMiningScreen,
      groupData,
      counters: { qu_xt: questions_by_turn, qu_t: turn_questions },
      isCreatePenalized,
      createPrizeCoins,
      user,
    } = this.props
    const { showInfo } = this.state
    const topic = groupData.topic || user.licenseData.topic ? user.licenseData.topic : ''
    let infoTooltip = 'tooltips.create_question'
    return (
      <Card
        changeScreen={() => changeMiningScreen('create_question')}
        signalNameId="mining.create_question"
        count_current={questions_by_turn - turn_questions}
        count_total={questions_by_turn}
        penalized={isCreatePenalized}
        prizeCoins={createPrizeCoins}
        infoTooltip={infoTooltip}
        tooltipValue={topic}
        showInfo={showInfo}
        icon="icon-question"
      />
    )
  }

  renderDebateQuestion() {
    const { changeMiningScreen, debatePrizeCoins, groupData, countDisputes, user } = this.props
    const { showInfo } = this.state

    const topic = groupData.topic || user.licenseData.topic ? user.licenseData.topic : ''
    const infoTooltip = 'tooltips.debate_question'
    return (
      <Card
        changeScreen={() => changeMiningScreen('vote_question')}
        signalNameId="mining.vote_question"
        count_current={0}
        count_total={1}
        prizeCoins={debatePrizeCoins}
        antiCoins={debatePrizeCoins}
        infoTooltip={infoTooltip}
        tooltipValue={topic}
        getDisputesHistory={() => this.goToDisputesHistory()}
        countDisputes={countDisputes}
        showInfo={showInfo}
        icon="icon-debate"
      />
    )
  }

  renderMiningFinished() {
    const { phase, addPopup, settings } = this.props

    return (
      <div
        className="btn--orange"
        onClick={() =>
          !settings.mineDisclaimer && phase == 2
            ? addPopup('mining_change_phase_popup')
            : this.closeMine()
        }
      >
        <span className="icon-rocket"> </span>
        <FormattedMessage id={phase == 2 ? 'mining.goFase3' : 'mining.back'} />
      </div>
    )
  }

  render() {
    const {
      counters: { qu_t: turn_questions, an_t: turn_answers },
      prevScreen,
      groupData,
      user,
    } = this.props
    const topic = groupData.topic || user.licenseData.topic ? user.licenseData.topic : ''

    const showInfo = () => {
      const showInfo = !this.state.showInfo
      this.setState({ showInfo })
    }

    const canGoNextPhase = turn_questions === 0 && turn_answers === 0
    return (
      <div
        className={`mina--layer vertical--center ${
          prevScreen && prevScreen == 'mining_default' ? 'fadeInLeft-animation' : ''
        }`}
      >
        <div className="signals--waves">
          <div className="signal-1"></div>
        </div>
        {topic ? (
          <div className="signal--topic">
            <b>
              <FormattedMessage id="welcome.topic" />
            </b>{' '}
            {topic}
          </div>
        ) : null}
        <div className="signal--title">
          <span>
            <FormattedMessage id="mining.title" />
          </span>
          <span className="signal--subtitle">
            <FormattedMessage id="mining.earnGCoins" />
          </span>
        </div>
        <div className="signal--get">
          <div className="btn" onClick={showInfo}>
            <div className="btn--primary">
              <span className="icon-information"> </span>
            </div>
          </div>
        </div>
        <div className="signals--list">
          {this.renderCreateQuestion()}
          {this.renderAnswerQuestion()}
          {this.renderDebateQuestion()}
        </div>
        {canGoNextPhase && this.renderMiningFinished()}
      </div>
    )
  }
}

const mapDispatchToProps = (dispatch) => ({
  addScreen: bindActionCreators(Game.actions.addScreen, dispatch),
  addPopup: bindActionCreators(Game.actions.addPopup, dispatch),
  removeScreen: bindActionCreators(Game.actions.removeScreen, dispatch),
  changeMiningScreen: bindActionCreators(actions.changeMiningScreen, dispatch),
  getDisputesList: bindActionCreators(quizzesActions.getDisputesList, dispatch),
  nextPhase: bindActionCreators(phaseActions.nextPhase, dispatch),
  getCountDisputes: bindActionCreators(actions.getCountDisputes, dispatch),
})

const mapStateToProps = (state) => ({
  counters: indicatorsSelectors.getCountersData(state),
  answerPrizeCoins: quizzesSelectors.getAnswerPrizeCoins(state),
  groupData: Firebase.selectors.getGroupData(state),
  createPrizeCoins: quizzesSelectors.getCreatePrizeCoins(state),
  settings: settingsSelectors.getSettings(state),
  debatePrizeCoins: quizzesSelectors.getDebatePrizeCoins(state),
  isAnswerPenalized: quizzesSelectors.isAnswerPenalized(state),
  phase: phaseSelectors.getCurrentPhase(state),
  isCreatePenalized: quizzesSelectors.isCreatePenalized(state),
  countDisputes: selectors.getCountDisputes(state),
  prevScreen: selectors.getPrevScreen(state),
  user: Auth.selectors.getUserInfo(state),
})

MiningSelectScreen.propTypes = {
  changeMiningScreen: PropTypes.func,
  addPopup: PropTypes.func,
  removeScreen: PropTypes.func,
  nextPhase: PropTypes.func,
  getDisputesList: PropTypes.func,
  countDisputes: PropTypes.number,
  counters: PropTypes.object,
  groupData: PropTypes.object,
  settings: PropTypes.object,
  user: PropTypes.object,
  answerPrizeCoins: PropTypes.number,
  phase: PropTypes.number,
  prevScreen: PropTypes.string,
  createPrizeCoins: PropTypes.number,
  debatePrizeCoins: PropTypes.number,
  isAnswerPenalized: PropTypes.bool,
  isCreatePenalized: PropTypes.bool,
  getCountDisputes: PropTypes.func,
}

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(MiningSelectScreen))
